import { render, staticRenderFns } from "./FriendshipContact.vue?vue&type=template&id=cfff7a40"
import script from "./FriendshipContact.vue?vue&type=script&lang=js"
export * from "./FriendshipContact.vue?vue&type=script&lang=js"
import style0 from "./FriendshipContact.vue?vue&type=style&index=0&id=cfff7a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports